import React from "react";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  ChevronDownIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const options = ["One", "Two", "Three"];

const DefaultButtonGroupHorzSplit = () => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Contained horizontally split button group"}
        value={
          'import React from "react";\n' +
          "import {\n" +
          "  Button,\n" +
          "  ButtonGroup,\n" +
          "  ClickAwayListener,\n" +
          "  Grow,\n" +
          "  MenuItem,\n" +
          "  MenuList,\n" +
          "  Paper,\n" +
          "  Popper,\n" +
          '} from "@mui/material";\n' +
          'import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";\n\nexport default function ContainedSplitButtonGroupHz() {  \nconst [open, setOpen] = React.useState(false);\n' +
          "  const anchorRef = React.useRef(null);\n" +
          "  const [selectedIndex, setSelectedIndex] = React.useState(1);\n" +
          "\n" +
          "  const handleMenuItemClick = (event, index) => {\n" +
          "    setSelectedIndex(index);\n" +
          "    setOpen(false);\n" +
          "  };\n" +
          "\n" +
          "  const handleToggle = () => {\n" +
          "    setOpen((prevOpen) => !prevOpen);\n" +
          "  };\n" +
          "\n" +
          "  const handleClose = (event) => {\n" +
          "    if (anchorRef.current && anchorRef.current.contains(event.target)) {\n" +
          "      return;\n" +
          "    }\n" +
          "    setOpen(false);\n" +
          '  };\n\nreturn(\n<>\n<ButtonGroup ref={anchorRef} aria-label="split button">\n' +
          "          <Button>{options[selectedIndex]}</Button>\n" +
          "          <Button\n" +
          '              size="small"\n' +
          '              aria-controls={open ? "split-button-menu" : undefined}\n' +
          '              aria-expanded={open ? "true" : undefined}\n' +
          '              aria-label="select merge strategy"\n' +
          '              aria-haspopup="menu"\n' +
          "              onClick={handleToggle}\n" +
          "          >\n" +
          "            <ArrowDropDownIcon />\n" +
          "          </Button>\n" +
          "        </ButtonGroup>\n" +
          "        <Popper\n" +
          "            sx={{\n" +
          "              zIndex: 1,\n" +
          "            }}\n" +
          "            open={open}\n" +
          "            anchorEl={anchorRef.current}\n" +
          "            role={undefined}\n" +
          "            transition\n" +
          "            disablePortal\n" +
          '            placement={"bottom-end"}\n' +
          "        >\n" +
          "          {({ TransitionProps, placement }) => (\n" +
          "              <Grow\n" +
          "                  {...TransitionProps}\n" +
          "                  style={{\n" +
          "                    transformOrigin:\n" +
          '                        placement === "bottom-end" ? "right top" : "right bottom",\n' +
          "                  }}\n" +
          "              >\n" +
          "                <Paper>\n" +
          "                  <ClickAwayListener onClickAway={handleClose}>\n" +
          '                    <MenuList id="split-button-menu" autoFocusItem>\n' +
          "                      {options.map((option, index) => (\n" +
          "                          <MenuItem\n" +
          "                              key={option}\n" +
          "                              disabled={index === 2}\n" +
          "                              selected={index === selectedIndex}\n" +
          "                              onClick={(event) =>\n" +
          "                                  handleMenuItemClick(event, index)\n" +
          "                              }\n" +
          "                          >\n" +
          "                            {option}\n" +
          "                          </MenuItem>\n" +
          "                      ))}\n" +
          "                    </MenuList>\n" +
          "                  </ClickAwayListener>\n" +
          "                </Paper>\n" +
          "              </Grow>\n" +
          "          )}\n" +
          "        </Popper>\n</>\n" +
          ")\n}"
        }
      >
        <ButtonGroup ref={anchorRef} aria-label="split button">
          <Button>{options[selectedIndex]}</Button>
          <Button
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            onClick={handleToggle}
          >
            <ChevronDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          placement={"bottom-end"}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-end" ? "right top" : "right bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        disabled={index === 2}
                        selected={index === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonGroupHorzSplit;
